import type { AdminReadiness } from './types'
import { authApiClient } from '~/lib/api-client'

const sportsVerifierClient = authApiClient.api['sports-verifier']

async function parseJson<T>(response: Response): Promise<T> {
  if (!response.ok) {
    let message = `Request failed with status ${response.status}`
    try {
      const body = await response.json() as {
        error?: { issues?: Array<{ message?: string }>, message?: string }
        message?: string
      }
      message = body.message ?? body.error?.message ?? body.error?.issues?.[0]?.message ?? message
    }
    catch {
      // Keep the status-based fallback when the backend returns a non-JSON error.
    }
    throw new Error(message)
  }
  return response.json() as Promise<T>
}

export async function getReadiness() {
  const response = await sportsVerifierClient.readiness.$get({
    header: { Authorization: '' },
  })
  return parseJson<AdminReadiness>(response)
}
